import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../../auth/auth.service';

/** Añade `Authorization: Bearer <JWT de Sirius>` a toda petición mientras haya token en sesión (nunca lo sobrescribe si ya viene). */
export const authTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const token = inject(AuthService).token();
  if (!token || req.headers.has('authorization')) return next(req);
  return next(req.clone({ setHeaders: { authorization: `Bearer ${token}` } }));
};
